// extracted by mini-css-extract-plugin
export default {"imageWrapper":"BI-z","hovered":"CI-z","hoverImage":"DI-z","mainImage":"EI-z","imageNoBackground":"FI-z","fullSizeImage":"GI-z"};